import {LANDSPRACHETODOMAINMAP} from "~/init/LANDSPRACHETODOMAINMAP";
import type { LocationQuery } from "vue-router";

export async function redirectToCanonicalURL(language: string, land: string, shopname:string) {
    if (typeof (LANDSPRACHETODOMAINMAP[land.toLowerCase()][language.toLowerCase()]) === "undefined") {
        return false;
    }
    const domain = import.meta.env.PROD ? (LANDSPRACHETODOMAINMAP[land.toLowerCase()][language.toLowerCase()]) : "localhost";
    const shopDIrectoryLocalized = getShopDirectoryLocalizedFromLanguage(language);
    const url = useRequestURL();
    const route = useRoute();
    if(domain === url.hostname && shopDIrectoryLocalized === route.params.shopdirectoryLocalized) {
        return false;
    }
    const link = getCanonicalURL(language, land, shopname, route.query);
    await navigateTo(link, {redirectCode:301, external:true})
    return true;
}

export function getCanonicalURL(language:string, land:string, shopname:string,  params?: LocationQuery) {
    const domain = import.meta.env.PROD ? (LANDSPRACHETODOMAINMAP[land.toLowerCase()][language.toLowerCase()]) : "localhost";
    const domainWithprotocol = (import.meta.env.PROD ? "https://" : "http://")+domain;
    const shopDIrectoryLocalized = getShopDirectoryLocalizedFromLanguage(language);

    let canonicalUrl = domainWithprotocol + "/" + shopDIrectoryLocalized + "/" + shopname;
    if (params && Object.keys(params).length > 0) {
        const urlParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => v && urlParams.append(key, v));
            } else if (value) {
                urlParams.append(key, value);
            }
        });

        const queryString = urlParams.toString();
        if (queryString) {
            canonicalUrl += `?${queryString}`;
        }
    }

    return canonicalUrl;
}

export async function redirectToThirdLevelDomain(url : string) {
    if(!url.startsWith("owayo")) {
        return true;
    }

    const link = import.meta.env.PROD ? "https://www."+url : "http://"+url;
    await navigateTo(link, {redirectCode:301, external:true})
    return true;
}

function getShopDirectoryLocalizedFromLanguage(language: string) {
    switch (language.toLowerCase()) {
        case "fr":
            return "boutique"
        case "en":
            return "store";
        case "es":
            return "tienda";
        case "no":
            return "butikk";
        default:
            return "shop";
    }
}
